/**
 * Articles Data Configuration
 *
 * Each article has metadata used for listing, filtering, and SEO.
 * MD content is fetched at runtime from public/articles/{slug}.md
 */

export const ARTICLE_CATEGORIES = {
  professions: [
    { value: "all", label: "כל המקצועות" },
    { value: "general", label: "כללי" },
    { value: "psychology", label: "פסיכולוגים" },
    { value: "speech-therapy", label: "קלינאות תקשורת" },
    { value: "occupational-therapy", label: "ריפוי בעיסוק" },
    { value: "physiotherapy", label: "פיזיותרפיה" },
    { value: "nutrition", label: "תזונאים ודיאטנים" },
    { value: "emotional-therapy", label: "טיפול רגשי" },
    { value: "social-work", label: "עבודה סוציאלית" },
    { value: "coaching", label: "אימון אישי" },
  ],
  topics: [
    { value: "all", label: "כל הנושאים" },
    { value: "clinic-management", label: "ניהול קליניקה" },
    { value: "technology", label: "טכנולוגיה" },
    { value: "marketing", label: "שיווק" },
    { value: "tips", label: "טיפים למטפלים" },
    { value: "documentation", label: "תיעוד" },
    { value: "finance", label: "ניהול פיננסי" },
  ],
};

export const ARTICLES = [
  {
    slug: "clinic-management-software-comparison",
    title: "תוכנות לניהול קליניקה – מדריך השוואה 2026: איך לבחור נכון",
    description:
      "השוואה בין תוכנות לניהול קליניקה בישראל: קריטריונים לבחירה, שאלות לבדיקה, חלופות נפוצות ומה חשוב למטפלים. מדריך אובייקטיבי לבחירת מערכת לניהול קליניקה.",
    date: "2026-06-14",
    author: "צוות CliniKit",
    readTime: 11,
    profession: "general",
    topic: "clinic-management",
    keywords: [
      "תוכנות לניהול קליניקה",
      "השוואת תוכנות לניהול קליניקה",
      "תוכנה לניהול קליניקה",
      "מערכת לניהול קליניקה",
      "חלופות לניהול קליניקה",
      "תוכנה למטפלים",
      "בחירת מערכת לקליניקה",
    ],
    image: null,
  },
  {
    slug: "clinic-management-software-guide",
    title: "תוכנה לניהול קליניקה – המדריך המלא למטפלים בשנת 2026",
    description:
      "מדריך מקיף לבחירת תוכנה לניהול קליניקה. השוואה בין מערכות, תכונות חובה, טיפים לבחירה נכונה וכל מה שמטפלים צריכים לדעת על מערכת לניהול קליניקה.",
    date: "2026-03-08",
    author: "צוות CliniKit",
    readTime: 12,
    profession: "general",
    topic: "clinic-management",
    keywords: [
      "תוכנה לניהול קליניקה",
      "מערכת לניהול קליניקה",
      "תוכנה למטפלים",
      "מערכת למטפלים",
      "ניהול קליניקה דיגיטלי",
      "תוכנה לפסיכולוגים",
      "מערכת לפסיכולוגים",
      "תוכנה לקלינאות תקשורת",
      "ניהול מטופלים",
    ],
    image: null,
  },
  {
    slug: "ai-therapy-summary-guide",
    title: "סיכום טיפול עם AI – איך זה באמת עובד ולמה מטפלים עוברים לזה",
    description:
      "מדריך מלא על סיכום טיפול עם AI: איך התהליך עובד, כמה זמן חוסכים, ולמה מטפלים עוברים לתיעוד טיפולי חכם. כל מה שצריך לדעת על AI בתיעוד.",
    date: "2026-03-08",
    author: "צוות CliniKit",
    readTime: 10,
    profession: "general",
    topic: "technology",
    keywords: [
      "סיכום טיפול עם AI",
      "תיעוד טיפולי",
      "סיכומי טיפול",
      "מערכת למטפלים",
      "תוכנה למטפלים",
      "AI בטיפול",
      "תיעוד טיפולים עם בינה מלאכותית",
      "סיכום מפגש טיפולי",
    ],
    image: null,
  },
  {
    slug: "opening-private-clinic-guide",
    title: "פתיחת קליניקה פרטית – מדריך מעשי מא' עד ת'",
    description:
      "פתיחת קליניקה פרטית – המדריך המעשי: עוסק פטור, ביטוח, תמחור, ניהול קליניקה, חשבוניות ושיווק. כולל עלויות אמיתיות וטעויות שכדאי להימנע מהן.",
    date: "2026-03-08",
    author: "צוות CliniKit",
    readTime: 14,
    profession: "general",
    topic: "tips",
    keywords: [
      "פתיחת קליניקה פרטית",
      "ניהול קליניקה פרטית",
      "מערכת למטפלים",
      "תוכנה למטפלים",
      "איך לפתוח קליניקה",
      "איך לפתוח קליניקה פרטית",
      "פתיחת קליניקה",
      "פתיחת מרפאה פרטית",
      "הקמת קליניקה פרטית",
      "קליניקה עצמאית",
      "מערכת לניהול קליניקה",
      "כמה עולה לפתוח קליניקה",
      "תוכנה לניהול קליניקה",
      "מערכת זימון תורים למטפלים",
      "תיק מטופל דיגיטלי",
      "ניהול יומן למטפלים",
      "חשבונית ירוקה למטפלים",
      "שיווק קליניקה",
      "עוסק פטור מטפלים",
    ],
    image: null,
  },
  {
    slug: "speech-therapy-software-guide",
    title: "תוכנה לקלינאיות תקשורת – 5 דברים שחייבים לבדוק",
    description:
      "מדריך לבחירת תוכנה לקלינאיות תקשורת: 5 קריטריונים חובה, מתבניות סיכום ייעודיות ועד מעקב התקדמות שפתית. מצאו את המערכת שמתאימה לכן.",
    date: "2026-03-08",
    author: "צוות CliniKit",
    readTime: 9,
    profession: "speech-therapy",
    topic: "clinic-management",
    keywords: [
      "תוכנה לקלינאיות תקשורת",
      "מערכת לקלינאות תקשורת",
      "תוכנה למטפלים",
      "מערכת למטפלים",
      "קלינאית תקשורת פרטית",
      "תיעוד קלינאות תקשורת",
      "מעקב התקדמות שפתית",
    ],
    image: null,
  },
  {
    slug: "reduce-no-shows-clinic-tips",
    title: "No-Show בקליניקה – 6 דרכים להפחית ביטולים והיעדרויות",
    description:
      "6 שיטות מעשיות להפחתת No-Show בקליניקה: מתזכורות אוטומטיות למטופלים ועד מדיניות ביטולים חכמה. טיפים שחוסכים אלפי שקלים בשנה.",
    date: "2026-03-08",
    author: "צוות CliniKit",
    readTime: 10,
    profession: "general",
    topic: "tips",
    keywords: [
      "תזכורות למטופלים",
      "ניהול יומן קליניקה",
      "מערכת למטפלים",
      "No-Show קליניקה",
      "ביטולים בקליניקה",
      "תזכורות SMS למטופלים",
      "מערכת תזכורות למטפלים",
      "ניהול קליניקה פרטית",
    ],
    image: null,
  },
  {
    slug: "invoices-for-therapists-financial-guide",
    title: "חשבוניות למטפלים – המדריך המלא לניהול פיננסי בקליניקה",
    description:
      "מדריך מקיף לניהול פיננסי בקליניקה: חשבוניות למטפלים, מעקב תשלומים, גבייה, מע\"מ וטיפים לסדר פיננסי עם תוכנה לניהול קליניקה.",
    date: "2026-03-08",
    author: "צוות CliniKit",
    readTime: 10,
    profession: "general",
    topic: "finance",
    keywords: [
      "חשבוניות למטפלים",
      "ניהול פיננסי קליניקה",
      "תוכנה לניהול קליניקה",
      "מערכת לניהול קליניקה",
      "גבייה למטפלים",
      "חשבונית ירוקה",
      "עוסק מורשה מטפלים",
      "תוכנה למטפלים",
    ],
    image: null,
  },
  {
    slug: "medical-data-security-guide-2026",
    title: "אבטחת מידע רפואי – מה כל מטפל חייב לדעת ב-2026",
    description:
      "מדריך לאבטחת מידע רפואי בקליניקה: דרישות חוקיות, פרטיות מטופלים, הצפנה וגיבויים. כל מה שמטפלים חייבים לדעת כדי לעמוד בחוק.",
    date: "2026-03-08",
    author: "צוות CliniKit",
    readTime: 11,
    profession: "general",
    topic: "technology",
    keywords: [
      "אבטחת מידע רפואי",
      "פרטיות מטופלים",
      "מערכת לניהול קליניקה",
      "הגנת פרטיות מטפלים",
      "הצפנת מידע רפואי",
      "תוכנה לניהול קליניקה",
      "חוק הגנת הפרטיות",
      "תוכנה למטפלים",
    ],
    image: null,
  },
  {
    slug: "excel-to-clinic-management-system",
    title: "מעבר מאקסל למערכת ניהול קליניקה – מדריך שלב אחרי שלב",
    description:
      "מדריך מעשי למעבר מאקסל למערכת לניהול קליניקה: שלבים, טיפים, ופתרונות לפחדים. כל מה שמטפלים צריכים כדי לעבור בקלות.",
    date: "2026-03-08",
    author: "צוות CliniKit",
    readTime: 10,
    profession: "general",
    topic: "clinic-management",
    keywords: [
      "מערכת לניהול קליניקה",
      "תוכנה למטפלים",
      "ניהול מטופלים",
      "מעבר מאקסל",
      "תוכנה לניהול קליניקה",
      "מערכת למטפלים",
      "ניהול קליניקה דיגיטלי",
    ],
    image: null,
  },
  {
    slug: "digital-forms-for-clinics",
    title: "טפסים דיגיטליים לקליניקה – למה לעבור לחתימה דיגיטלית",
    description:
      "מדריך לטפסים דיגיטליים בקליניקה: חתימה דיגיטלית למטפלים, טפסי הסכמה מודעת, שאלוני אינטייק ויתרונות הדיגיטציה לקליניקה.",
    date: "2026-03-08",
    author: "צוות CliniKit",
    readTime: 9,
    profession: "general",
    topic: "technology",
    keywords: [
      "טפסים דיגיטליים לקליניקה",
      "חתימה דיגיטלית למטפלים",
      "טפסי הסכמה",
      "תוכנה לניהול קליניקה",
      "מערכת לניהול קליניקה",
      "טפסי אינטייק",
      "הסכמה מודעת",
      "תוכנה למטפלים",
    ],
    image: null,
  },
  {
    slug: "private-clinic-marketing-guide-2026",
    title: "שיווק קליניקה פרטית – איך למשוך מטופלים חדשים ב-2026",
    description:
      "מדריך שיווק למטפלים: איך למשוך מטופלים לקליניקה פרטית ב-2026. שיטות חינמיות, רשתות חברתיות, SEO מקומי וטיפים מעשיים.",
    date: "2026-03-08",
    author: "צוות CliniKit",
    readTime: 11,
    profession: "general",
    topic: "marketing",
    keywords: [
      "שיווק קליניקה פרטית",
      "שיווק למטפלים",
      "קליניקה פרטית",
      "תוכנה לניהול קליניקה",
      "מערכת למטפלים",
      "שיווק דיגיטלי למטפלים",
      "קידום קליניקה בגוגל",
    ],
    image: null,
  },
  {
    slug: "psychology-software-guide",
    title: "תוכנה לפסיכולוגים – מה חשוב לדעת לפני שבוחרים מערכת",
    description:
      "מדריך לבחירת תוכנה לפסיכולוגים: 7 קריטריונים חובה, מאבטחת מידע ועד סיכומי AI. כל מה שפסיכולוגים צריכים במערכת לניהול קליניקה.",
    date: "2026-03-08",
    author: "צוות CliniKit",
    readTime: 7,
    profession: "psychology",
    topic: "clinic-management",
    keywords: [
      "תוכנה לפסיכולוגים",
      "מערכת לפסיכולוגים",
      "תוכנה למטפלים",
      "מערכת למטפלים",
      "תוכנה לניהול קליניקה",
      "אבטחת מידע רפואי",
      "סיכום טיפול עם AI",
    ],
    image: null,
  },
  {
    slug: "physiotherapy-documentation-guide",
    title: "תיעוד טיפולי לפיזיותרפיסטים – שיטות, דוגמאות וחיסכון זמן",
    description:
      "מדריך לתיעוד טיפולי בפיזיותרפיה: מודל SOAP, מעקב התקדמות, שיטות תיעוד ואיך תוכנה לפיזיותרפיסטים חוסכת שעה ביום.",
    date: "2026-03-08",
    author: "צוות CliniKit",
    readTime: 11,
    profession: "physiotherapy",
    topic: "documentation",
    keywords: [
      "תוכנה לפיזיותרפיסטים",
      "מערכת לפיזיותרפיסטים",
      "תיעוד טיפולי",
      "תוכנה למטפלים",
      "מערכת למטפלים",
      "SOAP פיזיותרפיה",
      "מעקב התקדמות טיפולי",
    ],
    image: null,
  },
  {
    slug: "occupational-therapy-clinic-management",
    title: "ריפוי בעיסוק בקליניקה פרטית – מדריך לניהול חכם",
    description:
      "מדריך לניהול קליניקה פרטית לריפוי בעיסוק: תיעוד, ניהול זמן, גבייה וכלים דיגיטליים. כל מה שמרפאים בעיסוק צריכים לדעת.",
    date: "2026-03-08",
    author: "צוות CliniKit",
    readTime: 11,
    profession: "occupational-therapy",
    topic: "clinic-management",
    keywords: [
      "תוכנה לריפוי בעיסוק",
      "ריפוי בעיסוק קליניקה פרטית",
      "מערכת למטפלים",
      "תוכנה למטפלים",
      "מערכת לניהול קליניקה",
      "תיעוד ריפוי בעיסוק",
      "ניהול קליניקה פרטית",
    ],
    image: null,
  },
  {
    slug: "efficient-payment-collection-therapists",
    title: "גבייה למטפלים – איך להפסיק לרדוף אחרי תשלומים",
    description:
      "מדריך גבייה יעילה למטפלים: 8 עקרונות, כלים טכנולוגיים, ואיך תוכנה לניהול קליניקה עושה את העבודה בשבילכם. תפסיקו לרדוף אחרי כסף.",
    date: "2026-03-08",
    author: "צוות CliniKit",
    readTime: 8,
    profession: "general",
    topic: "finance",
    keywords: [
      "גבייה למטפלים",
      "ניהול פיננסי קליניקה",
      "תוכנה לניהול קליניקה",
      "מערכת לניהול קליניקה",
      "מעקב תשלומים",
      "חשבוניות למטפלים",
      "תוכנה למטפלים",
    ],
    image: null,
  },
  {
    slug: "therapist-burnout-prevention-guide",
    title: "שחיקה במטפלים – הסימנים שאתם מפספסים ומה באמת עוזר",
    description:
      "מדריך למניעת שחיקה במטפלים: סימנים, סוגי שחיקה, ו-7 דרכים מעשיות להתמודד. גם כלים דיגיטליים שמפחיתים עומס ניהולי בקליניקה.",
    date: "2026-03-08",
    author: "צוות CliniKit",
    readTime: 8,
    profession: "general",
    topic: "tips",
    keywords: [
      "שחיקה במטפלים",
      "מניעת שחיקה",
      "מערכת למטפלים",
      "תוכנה למטפלים",
      "ניהול קליניקה פרטית",
      "עייפות חמלה",
      "תוכנה לניהול קליניקה",
    ],
    image: null,
  },
  {
    slug: "nutrition-clinic-software-guide",
    title: "תוכנה לדיאטנים ותזונאים – מדריך לבחירת מערכת לקליניקה",
    description:
      "מדריך לבחירת תוכנה לדיאטנים ותזונאים: ניהול תוכניות תזונה, מעקב משקל והתקדמות, תיעוד, גבייה ותזכורות. כל מה שצריך במערכת לניהול קליניקת תזונה.",
    date: "2026-06-15",
    author: "צוות CliniKit",
    readTime: 10,
    profession: "nutrition",
    topic: "clinic-management",
    keywords: [
      "תוכנה לדיאטנים",
      "תוכנה לתזונאים",
      "מערכת לדיאטנים",
      "ניהול קליניקת תזונה",
      "תוכנה לניהול קליניקה",
      "מעקב תזונתי דיגיטלי",
      "תוכנה למטפלים",
    ],
    image: null,
  },
  {
    slug: "emotional-therapy-clinic-guide",
    title: "תוכנה למטפלים רגשיים – ניהול קליניקה לטיפול רגשי",
    description:
      "מדריך למטפלים רגשיים על בחירת תוכנה לניהול קליניקה: תיעוד רגיש ומאובטח, סיכומי טיפול עם AI, תזכורות וגבייה. מערכת שמתאימה לטיפול רגשי.",
    date: "2026-06-17",
    author: "צוות CliniKit",
    readTime: 10,
    profession: "emotional-therapy",
    topic: "clinic-management",
    keywords: [
      "תוכנה למטפלים רגשיים",
      "מערכת לטיפול רגשי",
      "ניהול קליניקה לטיפול רגשי",
      "תוכנה למטפלים",
      "מערכת למטפלים",
      "תיעוד טיפול רגשי",
      "תוכנה לניהול קליניקה",
    ],
    image: null,
  },
  {
    slug: "social-work-clinic-management",
    title: "תוכנה לעובדים סוציאליים – ניהול קליניקה וטיפול פרטני",
    description:
      "מדריך לעובדים סוציאליים על ניהול קליניקה פרטית: תיעוד מקצועי, ניהול תיקי מטופלים, סודיות ואבטחת מידע, גבייה ותזכורות במערכת אחת בעברית.",
    date: "2026-06-19",
    author: "צוות CliniKit",
    readTime: 10,
    profession: "social-work",
    topic: "clinic-management",
    keywords: [
      "תוכנה לעבודה סוציאלית",
      "תוכנה לעובדים סוציאליים",
      "מערכת לעובד סוציאלי",
      "ניהול קליניקה פרטית",
      "תיעוד עבודה סוציאלית",
      "תוכנה למטפלים",
      "מערכת לניהול קליניקה",
    ],
    image: null,
  },
  {
    slug: "coaching-business-management-guide",
    title: "תוכנה למאמנים אישיים – ניהול עסק האימון מא' עד ת'",
    description:
      "מדריך למאמנים אישיים על ניהול עסק האימון: יומן וזימון פגישות, מעקב מתאמנים ומטרות, גבייה, חשבוניות ותזכורות. מערכת אחת לניהול קליניקת אימון.",
    date: "2026-06-21",
    author: "צוות CliniKit",
    readTime: 9,
    profession: "coaching",
    topic: "clinic-management",
    keywords: [
      "תוכנה למאמנים אישיים",
      "מערכת למאמן אישי",
      "ניהול עסק אימון",
      "תוכנה לאימון אישי",
      "ניהול מתאמנים",
      "תוכנה למטפלים",
      "מערכת לניהול קליניקה",
    ],
    image: null,
  },
  {
    slug: "whatsapp-appointment-reminders-guide",
    title: "תזכורות וואטסאפ למטופלים – המדריך המלא להפחתת ביטולים",
    description:
      "מדריך לתזכורות וואטסאפ למטופלים: איך הן מפחיתות No-Show, אישורי הגעה אוטומטיים, ומה ההבדל מ-SMS. כל מה שצריך לדעת על תזכורות אוטומטיות בקליניקה.",
    date: "2026-06-23",
    author: "צוות CliniKit",
    readTime: 9,
    profession: "general",
    topic: "technology",
    keywords: [
      "תזכורות וואטסאפ למטופלים",
      "אישור הגעה וואטסאפ",
      "תזכורות אוטומטיות לקליניקה",
      "הפחתת ביטולים",
      "תזכורות SMS למטופלים",
      "מערכת תזכורות למטפלים",
      "תוכנה לניהול קליניקה",
    ],
    image: null,
  },
  {
    slug: "green-invoice-for-therapists",
    title: "חשבונית ירוקה למטפלים – איך מפיקים חשבוניות דיגיטליות בקליניקה",
    description:
      "מדריך לחשבונית ירוקה למטפלים: איך מפיקים חשבוניות דיגיטליות, חיבור למערכת ניהול קליניקה, מעקב תשלומים ועמידה בדרישות מס הכנסה. מדריך מעשי.",
    date: "2026-06-24",
    author: "צוות CliniKit",
    readTime: 10,
    profession: "general",
    topic: "finance",
    keywords: [
      "חשבונית ירוקה למטפלים",
      "חשבונית דיגיטלית",
      "חשבוניות למטפלים",
      "הפקת חשבוניות קליניקה",
      "ניהול פיננסי קליניקה",
      "תוכנה לניהול קליניקה",
      "מערכת למטפלים",
    ],
    image: null,
  },
  {
    slug: "privacy-law-amendment-13-therapists",
    title: "תיקון 13 לחוק הגנת הפרטיות – מה כל מטפל חייב לדעת",
    description:
      "מדריך לתיקון 13 לחוק הגנת הפרטיות עבור מטפלים: מה השתנה, חובות חדשות, אבטחת מידע רפואי, וכיצד מתכוננים לעמידה בדרישות החוק בקליניקה הפרטית.",
    date: "2026-06-26",
    author: "צוות CliniKit",
    readTime: 11,
    profession: "general",
    topic: "technology",
    keywords: [
      "תיקון 13 לחוק הגנת הפרטיות",
      "חוק הגנת הפרטיות מטפלים",
      "אבטחת מידע רפואי",
      "פרטיות מטופלים",
      "עמידה ברגולציה קליניקה",
      "תוכנה לניהול קליניקה",
      "הגנת מידע בקליניקה",
    ],
    image: null,
  },
  {
    slug: "osek-patur-vs-murshe-therapists",
    title: "עוסק פטור או עוסק מורשה למטפלים – מה עדיף לקליניקה שלכם",
    description:
      "מדריך לבחירה בין עוסק פטור לעוסק מורשה למטפלים: תקרות הכנסה, מע\"מ, ניכוי הוצאות וחשבוניות. כל מה שצריך לדעת לפני פתיחת קליניקה פרטית.",
    date: "2026-06-27",
    author: "צוות CliniKit",
    readTime: 10,
    profession: "general",
    topic: "finance",
    keywords: [
      "עוסק פטור או מורשה",
      "עוסק פטור מטפלים",
      "עוסק מורשה מטפלים",
      "פתיחת עוסק מטפל",
      "מע\"מ למטפלים",
      "ניהול פיננסי קליניקה",
      "פתיחת קליניקה פרטית",
    ],
    image: null,
  },
  {
    slug: "how-to-write-therapy-summary",
    title: "איך לכתוב סיכום טיפול – מדריך, מבנה ודוגמאות למטפלים",
    description:
      "מדריך מעשי לכתיבת סיכום טיפול: מבנה נכון, מודל SOAP, מה לכלול ומה להשמיט, ודוגמאות. בנוסף איך סיכומי AI חוסכים שעות תיעוד בשבוע בקליניקה.",
    date: "2026-06-25",
    author: "צוות CliniKit",
    readTime: 11,
    profession: "general",
    topic: "documentation",
    keywords: [
      "איך לכתוב סיכום טיפול",
      "סיכום טיפול",
      "מבנה סיכום טיפול",
      "תיעוד טיפולי",
      "מודל SOAP",
      "סיכום טיפול עם AI",
      "תוכנה למטפלים",
    ],
    image: null,
  },
  {
    slug: "telehealth-online-therapy-guide",
    title: "טלתרפיה וטיפול אונליין – מדריך להקמת טיפול מרחוק בקליניקה",
    description:
      "מדריך לטלתרפיה וטיפול אונליין: איך מקימים טיפול מרחוק, כלים מומלצים, אבטחת מידע ופרטיות, גבייה ותיעוד. כל מה שמטפלים צריכים כדי להתחיל טיפול אונליין.",
    date: "2026-06-22",
    author: "צוות CliniKit",
    readTime: 10,
    profession: "general",
    topic: "technology",
    keywords: [
      "טלתרפיה",
      "טיפול אונליין",
      "טיפול מרחוק",
      "טיפול בווידאו",
      "קליניקה דיגיטלית",
      "תוכנה למטפלים",
      "תוכנה לניהול קליניקה",
    ],
    image: null,
  },
  {
    slug: "alternative-medicine-clinic-system",
    title: "מערכת לניהול קליניקת טיפולים אלטרנטיביים – מה חשוב לבדוק",
    description:
      "מדריך לבחירת מערכת לניהול קליניקת טיפולים אלטרנטיביים ורפואה משלימה: יומן, תיק מטופל, תזכורות, גבייה ותיעוד. מה חשוב לבדוק לפני שבוחרים תוכנה למרפאה.",
    date: "2026-06-16",
    author: "צוות CliniKit",
    readTime: 10,
    profession: "general",
    topic: "clinic-management",
    keywords: [
      "טיפולים אלטרנטיביים",
      "מערכת לניהול קליניקת טיפולים אלטרנטיביים",
      "רפואה משלימה",
      "תוכנה לנטורופתים",
      "מערכת לרפואה סינית",
      "ניהול מרפאה",
      "מערכת לניהול קליניקה",
    ],
    image: null,
  },
  {
    slug: "clinic-software-with-payment-processing",
    title: "תוכנה לניהול קליניקה עם סליקה – גביית תשלומים בכרטיס אשראי",
    description:
      "מדריך לתוכנה לניהול קליניקה עם סליקה: גביית תשלומים בכרטיס אשראי, סליקה מאובטחת, מעקב חובות וחשבוניות. איך בוחרים מערכת לניהול קליניקה עם סליקה.",
    date: "2026-06-18",
    author: "צוות CliniKit",
    readTime: 10,
    profession: "general",
    topic: "finance",
    keywords: [
      "תוכנה לניהול קליניקה עם סליקה",
      "מערכת לניהול קליניקה עם סליקה",
      "סליקה לקליניקה",
      "גביית תשלומים קליניקה",
      "סליקת אשראי למטפלים",
      "חשבוניות וגבייה",
      "תוכנה למטפלים",
    ],
    image: null,
  },
  {
    slug: "therapist-mobile-app-guide",
    title: "אפליקציה למטפלים – לנהל את הקליניקה מהנייד",
    description:
      "מדריך לאפליקציה למטפלים: ניהול יומן, מטופלים, תזכורות וגבייה מהנייד. איך אפליקציה למטפל חוסכת זמן ומה חשוב לבדוק במערכת ניהול קליניקה ניידת.",
    date: "2026-06-20",
    author: "צוות CliniKit",
    readTime: 9,
    profession: "general",
    topic: "technology",
    keywords: [
      "אפליקציה למטפלים",
      "אפליקציה למטפל",
      "אפליקציה לניהול קליניקה",
      "ניהול קליניקה מהנייד",
      "מערכת ניהול מטופלים",
      "תוכנה למטפלים",
      "מערכת לניהול קליניקה",
    ],
    image: null,
  },
  {
    slug: "patient-management-system-guide",
    title: "מערכת ניהול מטופלים – תיק מטופל דיגיטלי לקליניקה",
    description:
      "מדריך למערכת ניהול מטופלים: תיק מטופל דיגיטלי, היסטוריית טיפולים, מסמכים, תזכורות ואבטחת מידע. איך בוחרים מערכת לניהול מטופלים לקליניקה או מרפאה פרטית.",
    date: "2026-06-27",
    author: "צוות CliniKit",
    readTime: 10,
    profession: "general",
    topic: "clinic-management",
    keywords: [
      "מערכת ניהול מטופלים",
      "מערכת לניהול מטופלים",
      "תיק מטופל דיגיטלי",
      "ניהול מטופלים",
      "תוכנה לניהול מרפאה",
      "מערכת לניהול קליניקה",
      "ניהול קליניקה",
    ],
    image: null,
  },
];

export const getArticleBySlug = (slug) =>
  ARTICLES.find((article) => article.slug === slug);

export const getArticlesByFilter = ({ profession, topic }) => {
  return ARTICLES.filter((article) => {
    const matchProfession =
      !profession || profession === "all" || article.profession === profession;
    const matchTopic =
      !topic || topic === "all" || article.topic === topic;
    return matchProfession && matchTopic;
  });
};
